<template>
  <section class="container">
    <div class="login-wrapper">
      <br><br>
      <form method="post" id="loginFakeForm" @submit.prevent="fakeLogin">
        <label for="personal_code">Personal code:</label>
        <input type="text" name="code" id="personal_code" value="" />
        <button type="submit">Login</button>
      </form>
      <br><br>
    </div>
    <LoginAgreementModal
      id="agreementModal"
      :isCreateBtnDisabled="isAgreementRequestInProgress"
      :visible="isAgreementVisible"
      @close="closeAgreement"
      @agree="acceptAgreement" />
  </section>
</template>

<script>
import axios from 'axios';
import LoginAgreementModal from '../components/LoginAgreementModal';
import AcceptAgreement from '../mixins/AcceptAgreement.js';

const API_URL = import.meta.env.VITE_API_URL;

export default {
  components: {
    LoginAgreementModal,
  },
  mixins: [AcceptAgreement],
  methods: {
    fakeLogin() {
      axios.post(`${API_URL}/auth/fake`, { code: document.getElementById('personal_code').value })
        .then((response) => {
          const loginData = response.data;
          if (loginData.status === 'authorized') {
            this.login(loginData.token);
          } else if (loginData.status === 'authenticated') {
            this.showAgreement(loginData.token);
          }
        });
    },
  },
};
</script>
